import type { ComponentPropsWithoutRef } from 'react';
import { cx } from './cx';

export type BadgeTone = 'orange' | 'cyan' | 'navy' | 'neutral' | 'success' | 'warning' | 'danger';

export function Badge({ tone = 'orange', className, ...props }: ComponentPropsWithoutRef<'span'> & { tone?: BadgeTone }) {
  return <span className={cx('badge', tone !== 'orange' && `badge--${tone}`, className)} {...props} />;
}
